import React, { useEffect, useRef, useState } from 'react'
import {  Box, Button, Grid, TextField, Select, MenuItem,
  FormControl, InputLabel, InputAdornment, IconButton, Typography, Dialog } from '@mui/material'
import buttonStyle from '../../../styles/buttonStyle'
import { useNavigate } from 'react-router-dom';
import HeaderBox from '../../../components/HeaderBox';
import SingleAccordion from '../../../components/SingleAccordion';
// import { useState } from 'react';
import Complaint from '../../../components/enquiry/Complaint';
// import Stack from '@mui/material/Stack';
import SearchVRM from '../../../components/enquiry/SearchVRM';
import DateCalander from '../../../components/DateCalander';
import { CustomerData } from '../../../data/CustomerData';
import SearchOwner from '../../../components/enquiry/SearchOwner';
import Avatar from '@mui/material/Avatar';
// import { makeStyles, Dialog } from '@material-ui/core';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import ChatJob from '../Cashjob/ChatJob';
import CalculateIcon from '@mui/icons-material/Calculate';

const boxStyle = {
  root: {
    backgroundColor: 'white', 
    borderRadius: '5px',
    padding: 1
  },
};
const avatarStyle = {
  display: 'flex',
  width: '50px',
  height: '50px',
  bgcolor: '#c8e6c9',
};

function AddEnquiry() {
  // const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate()
  const inputRef= useRef()
  // const [isParts, setIsParts] = useState(false)
  const [allValue, setAllValue] = React.useState({ id: 1, VRM: '', Make:'', Model:'',Engine: '',Engine_power: '', Vehicle_Description:'', Mfr_Date:'', First_Used:'', Fuel_type:'', Gear_Type: '',Fleet_No: '',
  MOT:'',   MOT_Due:'',   Owner:'', Sale_Date:'',Sale_Dealer:'',});
  const [make, setMake] = React.useState(null);
  const [model, setModel] = React.useState(null);
  const [desc, setDesc] = React.useState(null);
  const [fuel, setFuel] = React.useState(null);
  const [engineNo, setEngineNo] = React.useState(null);
  const [enginePower, setEnginePower] = React.useState(null);
  const [ownerList, setOwnerList] = useState()
  const [ownerValue, setOwnerValue] = React.useState(null);
  const [ownerData, setOwnerData] = useState( {owner_Code:'', Owner:'',Address:'' ,Post_Code:'',Email :'',Mob_No:'',Street_Name: '',  vehicle_id: 1})

  useEffect(()=>{
    if(inputRef.current){
      inputRef.current.focus()
    }
  }, [])

  const getOwner =(id)=>{
    const owner= CustomerData.filter(item => item.vehicle_id === id)
    console.log(owner);
    setOwnerList(owner)
  }
  const getPostCode =(id)=>{
    const owner= CustomerData.filter(item => item.vehicle_id === id)
    console.log(owner);
    setOwnerList(owner)
  }

  return (
    <Box mt={2}>
      <Grid container spacing={1}>
      <Grid item xs={12} >
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}> ADD ENQUIRY DETAILS</Typography>
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='flex-end' >
          <Button sx={buttonStyle.root} onClick={() => navigate('/add_enquiry')}>Save</Button>&nbsp;
          <Button sx={buttonStyle.root} onClick={() => navigate('/enquiry')}>Cancel</Button>
            </Grid>
            </Grid>
            </Grid>
          
        <Grid item xs={12} mt={1}>
          <Box>
          <form>
          <Grid container spacing={1}>
              <Grid item xs={12} >
                <HeaderBox title='Enquiry Details'/>
              </Grid>
              
              <Grid item xs={12}>
              <Box sx={boxStyle.root} >
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} md={1.5}>
                    <TextField fullWidth size='small' label= 'Enquiry No' variant="outlined" required name='Enquiry No' disabled />
                    </Grid>
                    <Grid item xs={12} sm={6} md={1.5}>
                    <DateCalander  title='Enquiry Date'/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size='small' required >
                      <InputLabel id="demo-select-small-label">Enquiry Came Throgh </InputLabel>
                      <Select labelId="demo-select-small-label" id="demo-select-small"label="Enquiry Came Throgh ">
                        <MenuItem value=""></MenuItem>
                        <MenuItem value={20}>Walkin</MenuItem>
                        <MenuItem value={20}>Referral</MenuItem>
                        <MenuItem value={30}>Social Media</MenuItem>
                        <MenuItem value={30}>Repeat Complaint</MenuItem>
                      </Select>
                    </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size='small' required>
                      <InputLabel id="demo-select-small-label">Enquiry Status</InputLabel>
                      <Select labelId="demo-select-small-label" id="demo-select-small" label="Enquiry Status">
                        <MenuItem value=""></MenuItem>
                        <MenuItem value={20}>Enquiry</MenuItem>
                        <MenuItem value={20}>Estimate</MenuItem>
                        <MenuItem value={30}>Rejected</MenuItem>
                      </Select>
                    </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size='small' required  >
                      <InputLabel id="demo-select-small-label">Rejected Reason</InputLabel>
                      <Select labelId="demo-select-small-label" id="demo-select-small" label="Rejected Reason">
                        <MenuItem value=""></MenuItem>
                        <MenuItem value={20}>Parts Rate Hight</MenuItem>
                        <MenuItem value={30}>Service Not Available</MenuItem>
                        <MenuItem value={30}>Bay Not Available</MenuItem>
                      </Select>
                    </FormControl>
                    </Grid>
    
                  <Grid item xs={12} sm={6} md={1.5} >
                    <SearchVRM setAllValue={setAllValue} getOwner={getOwner} setOwnerData={setOwnerData} setOwnerValue={setOwnerValue} inputRef={inputRef}/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.5}>
                  <TextField fullWidth size='small' label="Make" variant="outlined" required name='Make' value={allValue?.Make? allValue?.Make :''}/>
                  </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth size='small' label="Model" variant="outlined" required name='Model' value={allValue?.Model? allValue?.Model:''}/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField fullWidth size='small' label="Vechicle Description" variant="outlined" required name='Vechicle Description' value={allValue?.Vehicle_Description? allValue?.Vehicle_Description: ''}/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.5}>
                    <TextField fullWidth size='small' label="Engine Number" variant="outlined" required name='Engine Number' value={allValue?.Engine? allValue?.Engine:''}/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.5}>
                  <TextField fullWidth size='small' label="Engine Power" variant="outlined" required name='Engine Power' value={allValue?.Engine_power? allValue?.Engine_power:''}/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                  <TextField fullWidth size='small' label="Fuel Type" variant="outlined" required name='Fuel Type' value={allValue?.Fuel_type? allValue?.Fuel_type:''}/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth size='small' label="Sale Date" variant="outlined" required name='Sale Date' value={allValue?.Sale_Date? allValue?.Sale_Date:''}/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth size='small' label="Sale Dealer" variant="outlined" required name='Sale Dealer' value={allValue?.Sale_Dealer? allValue?.Sale_Dealer:''}/>
                  </Grid>
                </Grid>
              </Box>
              </Grid>

              <Grid item xs={12} >
                <HeaderBox title='Owner Details' />
              </Grid>

              <Grid item xs={12}>
                <Box sx={boxStyle.root}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={2}>
                      <SearchOwner ownerList={ownerList} setOwnerData={setOwnerData} ownerValue={ownerValue} setOwnerValue={setOwnerValue}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <TextField fullWidth size='small'label="Street Name" variant="outlined" required name='street' value={ownerData?.Street_Name? ownerData?.Street_Name :''}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                    <TextField fullWidth size='small' label="Postal Code" variant="outlined" required name='Postal_Code' value={ownerData?.Post_Code? ownerData?.Post_Code :''}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <TextField fullWidth size='small' label="Address" variant="outlined" required name='address' value={ownerData?.Address? ownerData?.Address :''}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <TextField fullWidth size='small' label="Email ID" variant="outlined" required name='email' value={ownerData?.Email? ownerData?.Email :''}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} >
                      <TextField fullWidth size='small' label="Mobile" variant="outlined" required name='mobile' value={ownerData?.Mob_No? ownerData?.Mob_No :''}/>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* <Grid item xs={12}>
                <HeaderBox title='PARTS' isOpen={isParts} setIsOpen={setIsParts}/>
              </Grid> */}
              
              <Grid item xs={12}>
                <SingleAccordion component={<Complaint/>} title='Complaint'/>
              </Grid>
            </Grid> 
          </form>
          </Box>
        </Grid>

        <Grid item xs={12} display='flex' justifyContent='flex-end' mt={21}>
        <Box mt={2} >
          <Grid container spacing={1} >
            <Grid item xs={12} >
              <div>
                <Avatar sx={avatarStyle}>
                  <CalculateIcon sx={{color:'#66bb6a'}} onClick={handleClickOpen}/>
                </Avatar>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  sx={{ position: 'absolute',
                      // right: 10,
                      left: 1050,
                      top: 60,
                      width:450
                    }}
                >
                  <DialogContent>
                    <ChatJob/>
                  </DialogContent>
                  <DialogActions>
                    <Button sx={buttonStyle.root} onClick={handleClickOpen}> {" "} Save{" "} </Button> &nbsp;
                    <Button sx={buttonStyle.root} onClick={handleClose}  > {" "} Cancel{" "} </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      </Grid>
    </Box>
  )
}

export default AddEnquiry